import styles from './ExamineBlock.module.scss'
import RoundIcon from "@/Atoms/RoundIcon";
import React from "react";

export default (
  {
    onClick,
    className
  }: {
    onClick: (accepted: boolean) => void
    className?: string
  }
) => {

  const handleAccept = () => {
    onClick(true)
  }

  const handleDeny = () => {
    onClick(false)
  }
  return <div className={`${styles.container} ${className ?? ''}`}>

    <div className={styles.center}>
      <p>Kun je aangeven of dit bericht oké is?</p>
      <div className={styles.icons}>
        <RoundIcon className={styles.iconAccept} onClick={handleAccept} dark icon={<i className="fa-regular fa-thumbs-up"></i>}/>
        <RoundIcon className={styles.iconDeny} onClick={handleDeny} dark icon={<i className="fa-regular fa-thumbs-down"></i>}/>
      </div>
    </div>
  </div>
}